/**
 * created by hezq on 2019-11-21
 *
 * description: 数字工具类
 *
 */

let arrs = {};

/**
 * description: 数组中是否包含某个元素
 * @param {Object} el 
 * 
 * created by panjm on 2019-11-21
 * 
 */
Array.prototype.contains = function(el) {
	// 获取元素的数据类型
	let type = Object.prototype.toString.call(el);
	// 元素在数组中的位置
	let flag = this.indexOf(el);

	// 对象或数组类型类型
	if (type === "[object Object]" || type === "[object Array]") {
		for (let i = 0; i < this.length; i++) {
			if (JSON.stringify(this[i]) === JSON.stringify(el)) {
				flag = i;
				break;
			}
		}
	}

	return flag;
};

/**
 * description: 删除数组中某个元素
 * @param {Object} el 
 * 
 * created by panjm on 2019-11-21
 * 
 */
Array.prototype.remove = function(el) {
	// 获取元素的数据类型
	let type = Object.prototype.toString.call(el);
	// 获取元素在数组中位置
	let index = this.indexOf(el);

	// 对象或数组类型类型
	if (type === "[object Object]" || type === "[object Array]") {
		for (let i = 0; i < this.length; i++) {
			if (JSON.stringify(this[i]) === JSON.stringify(el)) {
				index = i;
				break;
			}
		}
	}

	if (index > -1) {
		this.splice(index, 1);
	}
};

/**
 * description: 获取数组中最大值
 * 
 * created by panjm on 2019-11-21
 * 
 */
Array.prototype.max = function() {
	return Math.max.apply({}, this);
};

/**
 * description: 获取数组中最小值
 * 
 * created by panjm on 2019-11-21
 * 
 */
Array.prototype.min = function() {
	return Math.min.apply({}, this);
};

/**
 * description: 数组去重-非json数组
 * @param {Object} obj 
 * 
 * created by panjm on 2019-11-21
 * 
 */
Array.prototype.uniquelize = function() {
	let ra = new Array();

	for (let i = 0; i < this.length; i++) {
		if (ra.contains(this[i]) === -1) {
			ra.push(this[i]);
		}
	}

	return ra;
};

/**
 * description: 数组去重-json数组
 * @param: [string] 唯一的key名，根据此键名进行去重
 * 
 * created by panjm on 2019-11-21
 * 
 */
Array.prototype.uniqueForJson = function(key) {
	if(!key){
		return [];
	}
	
	let res = [this[0]];

	for (let i = 1; i < this.length; i++) {
		let item = this[i];
		let repeat = false;
		
		for (let j = 0; j < res.length; j++) {
			if (item[key] === res[j][key]) {
				repeat = true;
				break;
			}
		}
		
		if (!repeat) {
			res.push(item);
		}
	}
	return res;
};

/**
 * description: 求两个数组的补集
 * @param {Array} a 数组A
 * @param {Array} b 数组B
 * 
 * created by panjm on 2019-11-21
 */
Array.prototype.complement = function(b) {
	let unionArr = this.union(b);
	let intersectArr = this.intersect(b);

	return unionArr.minus(intersectArr);
};

/**
 * description: 求两个数组的交集
 * @param {Array} b 数组B
 * 
 * created by panjm on 2019-11-21
 */
Array.prototype.intersect = function(b) {
	let intersectArr = [];

	this.uniquelize().forEach(function(o) {
		if (b.contains(o) !== -1) {
			intersectArr.push(o);
		}
	});

	return intersectArr;
};

/**
 * description: 求两个数组的差集
 * @param {Array} b 数组B
 * 
 * created by panjm on 2019-11-21
 */
Array.prototype.minus = function(b) {
	let minusArr = [];

	this.uniquelize().forEach(function(o) {
		if (b.contains(o) === -1) {
			minusArr.push(o);
		}
	});

	return minusArr;
};

/**
 * description: 求两个数组的并集
 * @param {Array} b 数组B
 * 
 * created by panjm on 2019-11-21
 */
Array.prototype.union = function(b) {
	return this.concat(b).uniquelize();
};

export default arrs;



// WEBPACK FOOTER //
// ./src/tools/arr/index.js